import types from './types';

const getChemicalProductHistory = id => ({
  type: types.GET_CHEMICAL_PRODUCT_HISTORY,
  params: { id }
});

const getInitialData = id => ({
  type: types.GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA,
  params: { id }
});

export default {
  getChemicalProductHistory,
  getInitialData
};
